import React, { useState } from "react";
import "./CustomTable.css";

const CustomTable = ({
  columns,
  data,
  onRowClick,
  headerStyle,
  rowStyle,
  itemsPerPage = 10,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageCount = Math.ceil(data?.length / itemsPerPage);

  const handlePageClick = (newPage) => {
    setCurrentPage(newPage);
  };

  const paginatedData = data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="custom__table_container">
      <div className="custom__table_container">
        <table className="custom__table">
          <thead className="custom__table_head" style={headerStyle}>
            <tr>
              {columns?.map((column, index) => (
                <th key={index} className="custom__table_header">
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="custom__table_body">
            {paginatedData?.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="custom__table_row"
                style={rowStyle}
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns?.map((column, colIndex) => (
                  <td key={colIndex} className="custom__table_cell">
                    {column.render && row?.editable !== false
                      ? column.render(row)
                      : row[column.key]}
                  </td>
                ))}
              </tr>
            ))}
            {(!paginatedData || paginatedData?.length < 1) && (
              <div className="custom__table_empty">Nothing to show</div>
            )}
          </tbody>
        </table>
      </div>
      {paginatedData?.length > itemsPerPage - 1 && (
        <Pagination
          currentPage={currentPage}
          pageCount={pageCount}
          onPageClick={handlePageClick}
        />
      )}
    </div>
  );
};

const Pagination = ({ currentPage, pageCount, onPageClick }) => {
  let startPage, endPage;
  if (pageCount <= 5) {
    // Less than 5 total pages so show all
    startPage = 1;
    endPage = pageCount;
  } else {
    // More than 5 total pages so calculate start and end pages
    if (currentPage <= 3) {
      startPage = 1;
      endPage = 5;
    } else if (currentPage + 2 >= pageCount) {
      startPage = pageCount - 4;
      endPage = pageCount;
    } else {
      startPage = currentPage - 2;
      endPage = currentPage + 2;
    }
  }

  // Generate the range of displayed page numbers
  const pages = Array.from(
    { length: endPage + 1 - startPage },
    (_, idx) => startPage + idx
  );

  return (
    <div className="custom__table_pagination">
      {/* Display the first page and ellipsis if needed */}
      {startPage > 1 && (
        <>
          <button
            onClick={() => onPageClick(1)}
            className="custtabpag__page_item"
          >
            1
          </button>
          {startPage > 2 && <span className="custtabpag__page_item">...</span>}
        </>
      )}
      {/* Display page numbers */}
      {pages.map((page) => (
        <button
          key={page}
          className={`custtabpag__page_item ${
            page === currentPage ? "custtabpag__page_itemactive" : ""
          }`}
          onClick={() => onPageClick(page)}
        >
          {page}
        </button>
      ))}
      {/* Display the last page and ellipsis if needed */}
      {endPage < pageCount && (
        <>
          {endPage < pageCount - 1 && (
            <span className="custtabpag__page_item">...</span>
          )}
          <button
            onClick={() => onPageClick(pageCount)}
            className="custtabpag__page_item"
          >
            {pageCount}
          </button>
        </>
      )}
    </div>
  );
};

export default CustomTable;
